// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pj-0";